/**
 * i18n — minimal translation helper for the game web app.
 *
 * Same contract as the RN app's t(key, 中文預設) pattern:
 *   - keys are flat dotted strings, catalogued in ./locales/*.json
 *   - the inline fallback keeps the UI readable even if a key is missing
 *   - CI parity check (scripts/check-i18n-parity.mjs) requires every
 *     t() key used in game/src to exist in BOTH locale files
 *
 * Locale resolution: ?lang= URL param > navigator.language > zh-TW.
 * The App opens the game with ?lang=<app locale> so both stay in sync.
 */
import zhTW from './locales/zh-TW.json'
import en from './locales/en.json'

const LOCALES = { 'zh-TW': zhTW, en }

function detectLocale() {
  if (typeof window !== 'undefined') {
    const param = new URLSearchParams(window.location.search).get('lang')
    if (param && LOCALES[param]) return param
  }
  if (typeof navigator !== 'undefined' && typeof navigator.language === 'string') {
    return navigator.language.startsWith('zh') ? 'zh-TW' : 'en'
  }
  return 'zh-TW'
}

let currentLocale = detectLocale()

export function setLocale(locale) {
  if (LOCALES[locale]) currentLocale = locale
}

export function getLocale() {
  return currentLocale
}

/**
 * @param {string} key      catalogue key, e.g. 'game.title'
 * @param {string} fallback inline default text (zh-TW)
 * @param {Record<string, string|number>} [vars]  {n} style interpolation
 * @returns {string}
 */
export function t(key, fallback = key, vars) {
  let text = LOCALES[currentLocale]?.[key] ?? LOCALES['zh-TW'][key] ?? fallback
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      text = text.replaceAll(`{${k}}`, String(v))
    }
  }
  return text
}
